import { UIHeading5, UIText2 } from '@cian/ui-kit';
import * as React from 'react';

import { useImageLoadingHandlers } from './hooks';
import { RecommendationPriceDiscount as PriceDiscount } from '../RecommendationPriceDiscount';
import { TRecommendation } from '../../types/recommendation';

import * as styles from './styles.css';

interface IRecommendationProps extends TRecommendation {
  onClick(analyticsData?: object): void;
  favoriteButton: React.ReactNode;
  labels: React.ReactNode;
}

export const Recommendation: React.FC<IRecommendationProps> = ({
  imageUrl,
  title: price,
  description,
  analyticsData,
  href,
  onClick,
  favoriteButton,
  labels,
  discount,
  info,
}) => {
  const { onLoad, onError } = useImageLoadingHandlers({
    domain: 'FavoriteRecommendations',
    src: imageUrl,
  });

  return (
    <a
      onClick={() => onClick(analyticsData)}
      href={href}
      target="_blank"
      className={styles['container']}
      rel="noreferrer"
    >
      {labels}
      <span className={styles['favorite']} data-testid="favoriteButton">
        {favoriteButton}
      </span>
      <img src={imageUrl} className={styles['image']} onLoad={onLoad} onError={onError} />
      <div className={styles['price']} data-testid="price">
        <UIHeading5>{discount ? discount.newPrice : price}</UIHeading5>
        {discount && <PriceDiscount oldPrice={discount.oldPrice} percent={discount.percent} />}
      </div>
      {description && (
        <UIText2 display="inline" whiteSpace="nowrap" data-testid="description">
          {description}
        </UIText2>
      )}
      {info && (
        <UIText2 display="inline" whiteSpace="nowrap" data-testid="info">
          {info}
        </UIText2>
      )}
    </a>
  );
};
